import {Injectable} from '@angular/core';
import {BaseRequestOptions, Http, Response, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Rx';

import {Reponse} from './reponse.model';
import {Question} from '../../formation';
import {CONSTANTS} from '../../../cadens.constants';

@Injectable()
export class ReponseService {

    private resourceUrl = 'api/reponses';
    private resourcemajordisciplineUrl = 'api/reponses/majordiscipline';
    private resourcePublicUrl = 'api/public/reponses';
    private resourceAllReponsesCandidature = 'api/reponses/reponsesparcandidature';

    private static createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }

    constructor(private http: Http) { }

    update(questions: Question[]): Observable<Question[]> {
        return this.updateAvecReferent(questions, null);
    }

    updateAvecReferent(questions: Question[], referentKey): Observable<Question[]> {
        if (questions == null ) {
            return null;
        }
        let params = new URLSearchParams();
        if (referentKey) {
            params.set('referentKey', referentKey);
        }
        let copy: Question[] = questions.filter(q => q.typeReponse !== CONSTANTS.CASPARTICULIER ).slice(0);
        return this.http.put(this.resourcePublicUrl, copy, {search: params}).map((res: Response) => {
            return res.json();
        });
    }

    /*    find(id: number): Observable<Reponse> {
            return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
                return res.json();
            });
        }*/

    findMajorDiscipline(): Observable<Reponse[]> {
        return this.http.get(`${this.resourcemajordisciplineUrl}`).map((res: Response) => {
            return res.json();
        });
    }

    query(req?: any): Observable<Response> {
        let params = new URLSearchParams();
        if (req && req.candidatureFormationId) {
            params.set('candidatureFormationId', req.candidatureFormationId);
        }
        if (req && req.referentId) {
            params.set('referentId', req.referentId);
        }
        if (req && req.referentKey) {
            params.set('referentKey', req.referentKey);
        }
        return this.http.get(this.resourcePublicUrl, { search: params })
        ;
    }

    getAllReponsesCandidature(): Observable<Response> {
        return this.http.get(this.resourceAllReponsesCandidature).map((res: Response) => {
            return res;
        });
    }

    /*    delete(id: number): Observable<Response> {
            return this.http.delete(`${this.resourceUrl}/${id}`);
        }*/


}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/formation/reponse.service.ts